import React from 'react';

function Logo(props) {
  return <img alt="Logo" src="/static/logo-w.png" {...props} />;
}

export default Logo;
